"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var statementApi = _interopRequireWildcard(require("@/api/merchantStatement"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
function getPreviousMonthFirstTime(dateTime) {
  var dateParts = String(dateTime).slice(0, 10).split('-');
  var year = Number(dateParts[0]);
  var month = Number(dateParts[1]) - 1;
  if (month === 0) {
    year -= 1;
    month = 12;
  }
  return "".concat(year, "-").concat(String(month).padStart(2, '0'), "-01 00:00:00");
}
var _default = exports.default = {
  name: 'GenerateDialog',
  data: function data() {
    var now = new Date();
    var defaultStart = new Date(now.getFullYear(), now.getMonth() - 1, 1, 0, 0, 0);
    var prevMonthEnd = new Date(now.getFullYear(), now.getMonth(), 0, 23, 59, 59);
    var pad = function pad(n) {
      return String(n).padStart(2, '0');
    };
    var fmt = function fmt(d) {
      return "".concat(d.getFullYear(), "-").concat(pad(d.getMonth() + 1), "-").concat(pad(d.getDate()), " ").concat(pad(d.getHours()), ":").concat(pad(d.getMinutes()), ":").concat(pad(d.getSeconds()));
    };
    return {
      visible: false,
      submitLoading: false,
      merchantOptions: [],
      merchantOptionsLoading: false,
      overlapCount: null,
      settledAfterSaleLoading: false,
      settledAfterSaleOrders: [],
      settledAfterSaleRequestId: 0,
      crossMonthLoading: false,
      crossMonthOrderData: {
        list: [],
        total: 0
      },
      crossMonthPage: {
        page: 1,
        limit: 5
      },
      crossMonthRequestId: 0,
      settledAfterSaleDetailParam: {
        detailType: 2,
        orderIds: []
      },
      crossMonthDetailParam: {
        detailType: 3,
        orderIds: []
      },
      initializedOrderIds: {
        settledAfterSale: {},
        crossMonth: {}
      },
      form: {
        merchantType: '',
        merchantId: '',
        dateRange: []
      },
      rules: {
        merchantType: [{
          required: true,
          message: '请选择商家类型',
          trigger: 'change'
        }],
        merchantId: [{
          required: true,
          message: '请选择商家',
          trigger: 'change'
        }],
        dateRange: [{
          required: true,
          message: '请选择账单周期',
          trigger: 'change'
        }]
      },
      defaultDateRange: [fmt(defaultStart), fmt(prevMonthEnd)]
    };
  },
  computed: {
    canLoadOrderPreview: function canLoadOrderPreview() {
      return Boolean(this.form.merchantId && this.form.dateRange && this.form.dateRange.length === 2);
    }
  },
  methods: {
    open: function open() {
      this.form = {
        merchantType: '',
        merchantId: '',
        dateRange: _toConsumableArray(this.defaultDateRange)
      };
      this.merchantOptions = [];
      this.overlapCount = null;
      this.resetOrderPreview();
      this.visible = true;
    },
    loadMerchantOptions: function loadMerchantOptions(keyword) {
      var _this = this;
      if (!keyword) keyword = '';
      this.merchantOptionsLoading = true;
      statementApi.getMerchantOptionsApi(keyword, this.form.merchantType).then(function (res) {
        _this.merchantOptions = res || [];
      }).catch(function () {
        _this.merchantOptions = [];
        _this.$message.error('加载商家列表失败，请稍后重试');
      }).finally(function () {
        _this.merchantOptionsLoading = false;
      });
    },
    handleMerchantSearch: function handleMerchantSearch(data) {
      this.loadMerchantOptions(data);
    },
    onMerchantTypeChange: function onMerchantTypeChange() {
      this.form.merchantId = '';
      this.merchantOptions = [];
      this.overlapCount = null;
      this.resetOrderPreview();
      if (this.form.merchantType) {
        this.loadMerchantOptions('');
      }
    },
    onMerchantChange: function onMerchantChange() {
      this.overlapCount = null;
      this.resetOrderPreview();
      if (!this.form.merchantId) return;
      this.checkOverlap();
      this.loadOrderPreview();
    },
    onDateRangeChange: function onDateRangeChange(val) {
      this.resetOrderPreview();
      if (!val || val.length !== 2) {
        this.overlapCount = null;
        return;
      }
      this.checkOverlap();
      this.loadOrderPreview();
    },
    loadOrderPreview: function loadOrderPreview() {
      if (!this.canLoadOrderPreview) return;
      this.loadSettledAfterSaleOrders();
      this.loadCrossMonthOrders();
    },
    checkOverlap: function checkOverlap() {
      var _this2 = this;
      if (!this.canLoadOrderPreview) {
        this.overlapCount = null;
        return;
      }
      statementApi.statementCheckOverlapApi(this.getOrderPreviewParams()).then(function (res) {
        _this2.overlapCount = res;
      }).catch(function () {
        _this2.overlapCount = null;
      });
    },
    getOrderPreviewParams: function getOrderPreviewParams() {
      return {
        merchantId: this.form.merchantId,
        periodStart: this.form.dateRange[0],
        periodEnd: this.form.dateRange[1]
      };
    },
    loadSettledAfterSaleOrders: function loadSettledAfterSaleOrders() {
      var _this3 = this;
      if (!this.canLoadOrderPreview) return;
      var requestId = ++this.settledAfterSaleRequestId;
      var params = this.getOrderPreviewParams();
      this.settledAfterSaleLoading = true;
      var requestTask = statementApi.statementSettledAfterSaleOrderListApi(params);
      requestTask.then(function (data) {
        if (requestId !== _this3.settledAfterSaleRequestId) return;
        var list = Array.isArray(data) ? data : data && data.list || [];
        _this3.initializeOrderInclusion('settledAfterSale', list);
        _this3.settledAfterSaleOrders = list;
      }).catch(function () {
        if (requestId === _this3.settledAfterSaleRequestId) _this3.settledAfterSaleOrders = [];
      }).finally(function () {
        if (requestId === _this3.settledAfterSaleRequestId) _this3.settledAfterSaleLoading = false;
      });
    },
    loadCrossMonthOrders: function loadCrossMonthOrders() {
      var _this4 = this;
      if (!this.canLoadOrderPreview) return;
      var requestId = ++this.crossMonthRequestId;
      var periodEnd = this.form.dateRange[0];
      var params = {
        merchantId: this.form.merchantId,
        periodStart: getPreviousMonthFirstTime(periodEnd),
        periodEnd: periodEnd,
        page: this.crossMonthPage.page,
        limit: this.crossMonthPage.limit
      };
      this.crossMonthLoading = true;
      var requestTask = statementApi.statementCrossMonthOrderListApi(params);
      requestTask.then(function (data) {
        if (requestId !== _this4.crossMonthRequestId) return;
        var list = Array.isArray(data) ? data : data && data.list || [];
        _this4.initializeOrderInclusion('crossMonth', list);
        _this4.crossMonthOrderData = {
          list: list,
          total: data && data.total !== undefined ? data.total : list.length
        };
      }).catch(function () {
        if (requestId === _this4.crossMonthRequestId) {
          _this4.crossMonthOrderData = {
            list: [],
            total: 0
          };
        }
      }).finally(function () {
        if (requestId === _this4.crossMonthRequestId) _this4.crossMonthLoading = false;
      });
    },
    getOrderDetailParam: function getOrderDetailParam(orderType) {
      return orderType === 'settledAfterSale' ? this.settledAfterSaleDetailParam : this.crossMonthDetailParam;
    },
    initializeOrderInclusion: function initializeOrderInclusion(orderType, list) {
      var _this5 = this;
      var initializedOrderIds = this.initializedOrderIds[orderType];
      var detailParam = this.getOrderDetailParam(orderType);
      list.forEach(function (item) {
        if (item.orderId === null || item.orderId === undefined) return;
        var orderKey = String(item.orderId);
        if (initializedOrderIds[orderKey]) return;
        _this5.$set(initializedOrderIds, orderKey, true);
        if (item.includedInStatement && !_this5.isOrderIncluded(orderType, item.orderId)) {
          detailParam.orderIds.push(item.orderId);
        }
      });
    },
    isOrderIncluded: function isOrderIncluded(orderType, orderId) {
      var detailParam = this.getOrderDetailParam(orderType);
      return detailParam.orderIds.some(function (item) {
        return String(item) === String(orderId);
      });
    },
    handleOrderInclusionChange: function handleOrderInclusionChange(orderType, row) {
      if (row.orderId === null || row.orderId === undefined) return;
      var detailParam = this.getOrderDetailParam(orderType);
      var orderIndex = detailParam.orderIds.findIndex(function (item) {
        return String(item) === String(row.orderId);
      });
      if (orderIndex >= 0) {
        detailParam.orderIds.splice(orderIndex, 1);
        return;
      }
      detailParam.orderIds.push(row.orderId);
    },
    handleCrossMonthSizeChange: function handleCrossMonthSizeChange(limit) {
      this.crossMonthPage.limit = limit;
      this.crossMonthPage.page = 1;
      this.loadCrossMonthOrders();
    },
    handleCrossMonthPageChange: function handleCrossMonthPageChange(page) {
      this.crossMonthPage.page = page;
      this.loadCrossMonthOrders();
    },
    resetOrderPreview: function resetOrderPreview() {
      this.settledAfterSaleRequestId += 1;
      this.crossMonthRequestId += 1;
      this.settledAfterSaleLoading = false;
      this.settledAfterSaleOrders = [];
      this.crossMonthLoading = false;
      this.crossMonthOrderData = {
        list: [],
        total: 0
      };
      this.crossMonthPage = {
        page: 1,
        limit: 5
      };
      this.settledAfterSaleDetailParam = {
        detailType: 2,
        orderIds: []
      };
      this.crossMonthDetailParam = {
        detailType: 3,
        orderIds: []
      };
      this.initializedOrderIds = {
        settledAfterSale: {},
        crossMonth: {}
      };
    },
    formatAmount: function formatAmount(value) {
      var amount = Number(value);
      return Number.isNaN(amount) ? '-' : "\uFFE5".concat(amount.toFixed(2));
    },
    formatSignedAmount: function formatSignedAmount(value) {
      var amount = Number(value);
      if (Number.isNaN(amount)) return '-';
      var sign = amount > 0 ? '+' : amount < 0 ? '-' : '';
      return "".concat(sign, "\uFFE5").concat(Math.abs(amount).toFixed(2));
    },
    getAmountClass: function getAmountClass(value) {
      var amount = Number(value);
      if (amount > 0) return 'amount-positive';
      if (amount < 0) return 'amount-negative';
      return '';
    },
    handleSubmit: function handleSubmit() {
      var _this6 = this;
      this.$refs.formRef.validate(function (valid) {
        if (!valid) return;
        _this6.submitLoading = true;
        var data = {
          merchantId: _this6.form.merchantId,
          periodStart: _this6.form.dateRange[0],
          periodEnd: _this6.form.dateRange[1],
          settledAfterSaleOrderAdjustments: {
            detailType: _this6.settledAfterSaleDetailParam.detailType,
            orderIds: _toConsumableArray(_this6.settledAfterSaleDetailParam.orderIds)
          },
          crossMonthOrderAdjustments: {
            detailType: _this6.crossMonthDetailParam.detailType,
            orderIds: _toConsumableArray(_this6.crossMonthDetailParam.orderIds)
          }
        };
        statementApi.statementGenerateApi(data).then(function () {
          _this6.$message.success('对账单生成任务已提交');
          _this6.visible = false;
          _this6.$emit('refresh');
        }).catch(function (err) {
          _this6.$message.error(err.message || '生成失败，请稍后重试');
        }).finally(function () {
          _this6.submitLoading = false;
        });
      });
    }
  }
};